// Should be rewritten to avoid global imports.
$ = window.$ = window.JQuery = require("jquery");
require("bootstrap");
require("jquery-ui/ui/widgets/autocomplete");
require("jquery-ui/ui/widgets/tooltip");
$(document).ready(() => {
  $('.a-nav-list [data-toggle="collapse"].collapsed').on("click", () => {
    $("#overlay").addClass("show");
  });

  $(
    '.a-nav-list [data-toggle="collapse"]:not(.collapsed), .a-close, #overlay'
  ).on("click", () => {
    $("#overlay").removeClass("show");
  });
});

require("./table");
require("./autocomplete");
require("./input-clear");
require("./emphasize-word");
require("./global-alert");
require("./intranet-service-status");
require("./what-we-do");
require("./intra-tabs");
require("./intranet-news-mentions");
require("./profile-file-upload");
require("./ie-warning.js");
require("./report-page.js");
require("./datepicker.js");
require("./fileUpload");
require("./form-file-upload");
